import { render, staticRenderFns } from "./TasksCalendar.vue?vue&type=template&id=78641230&scoped=true"
import script from "./TasksCalendar.vue?vue&type=script&lang=js"
export * from "./TasksCalendar.vue?vue&type=script&lang=js"
import style0 from "./TasksCalendar.vue?vue&type=style&index=0&id=78641230&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78641230",
  null
  
)

export default component.exports